import * as React from "react";

const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    id="Layer_1_unique"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="100%"
    height="100%"
    x="0px"
    y="0px"
    viewBox="0 0 120 64.5"
    style={{
      enableBackground: "new 0 0 120 64.5",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {`
        .iso_st0{display:none;fill:none;stroke:${strokeColor};stroke-width:0.6042;stroke-miterlimit:10;}
        .iso_st1{fill:none;stroke:${strokeColor};stroke-width:0.6042;stroke-miterlimit:10;}
        .iso_st2{display:none;fill:none;stroke:${strokeColor};stroke-width:0.7549;stroke-miterlimit:9.9982;}
        .iso_st3{display:none;}
        .iso_st4{display:inline;fill:none;stroke:${strokeColor};stroke-width:0.7549;stroke-miterlimit:10;}
        .iso_st5{display:none;fill:none;stroke:${strokeColor};stroke-width:0.7549;stroke-miterlimit:10;}
        .iso_st6{fill:none;stroke:${strokeColor};stroke-width:0.6027;stroke-miterlimit:10;}
        .iso_st7{fill:none;stroke:${strokeColor};stroke-width:0.4531;stroke-miterlimit:10;}
        .iso_st8{fill:none;stroke:${strokeColor};stroke-width:0.6042;stroke-miterlimit:9.9961;}
        .iso_st9{fill:none;stroke:${strokeColor};stroke-width:0.6027;stroke-miterlimit:10.0006;}
      `}
    </style>
    <g id="Layer_1_00000057866519123740642160000007098581999562517395_">
      <g id="Layer_1_00000052815706336185140060000010184608169179766144_">
        <g id="Layer_1_00000124843414886120022300000008603847642599627423_">
          <g id="Layer_1_00000168803079670745848200000003522177890262615425_">
            <g id="Layer_2_00000005953711694740312420000001306363711486528651_" />
            <g id="Layer_1_00000103222774645540541050000005139477364094571910_">
              <g id="Layer_4_00000049934109083756324810000015099088110705302955_">
                <path
                  className="iso_st0"
                  d="M57.2,36.7c-5.2,2.2-4.7,12.4-4.9,14.9c0,0,0,0,0,0.3"
                />
                <path
                  className="iso_st1"
                  d="M56.8,41.8L56.8,41.8c1.4-2.1,2.1-2.9,2.4-2.8c0,0,11.6,3,15.6,3.5"
                />
                <path
                  className="iso_st0"
                  d="M58.1,55c-0.7-4.4,1.3-8.2,3.7-8.2c2.4,0,5,3.2,5.5,7.6s-1.3,8.2-3.7,8.2C60.9,62.8,58.6,59.6,58.1,55z"
                />
                <g id="Layer_2_00000035522350009171966180000007139185092383136160_">
                  <line className="iso_st0" x1={54} y1={52.2} x2={23.8} y2={42.4} />
                  <path
                    className="iso_st1"
                    d="M60.7,57c13.6,7.4,27.5,4.2,54.2-5.2"
                  />
                </g>
              </g>
              <path className="iso_st0" d="M58.7,28.8c-0.7,1.7-2.2,4.9-1.7,8.1" />
            </g>
            <ellipse className="iso_st2" cx={22.6} cy={45.8} rx={0.8} ry={0.8} />
            <g
              id="Layer_2_00000111192914016998989680000016321774623818434183_"
              className="iso_st3"
            >
              <path
                className="iso_st4"
                d="M33.7,54l-0.8-4.6C32.1,41,28.1,28.6,20.3,27L19,26.7c-6.7,0.2-7.3,7.8-8,14.1v2.1"
              />
            </g>
            <path
              className="iso_st5"
              d="M25.1,30.1h-2.9c-10.7,0.4-9.6,12.8-9.4,15.3l0.4,2.1c1.9,12,11.1,15.9,18.5,10.7c3.6-2.9,4-4.2,4-4.2"
            />
            <path className="iso_st1" d="M74.3,42.4c8.4,1.7,18.8-1.8,27-3.9" />
          </g>
          <path className="iso_st6" d="M10.7,32" />
          <path
            className="iso_st7"
            d="M22.3,13.9L21,14.1c-0.5,0.2-0.8,0.2-1.3,0l-0.5-0.2c0,0-0.2-0.2-0.7-0.2l-2.2-0.2c-0.2,0-0.5-0.2-0.5-0.5 v-1c0-0.2,0-0.5,0.5-0.5h1.3c0.5,0,0.8,0,1.3,0.2l0.7,0.5l0.5,0.8h0.3L22.3,13.9"
          />
          <line className="iso_st7" x1={20.3} y1={12.9} x2={19.6} y2={14.1} />
        </g>
        <g id="Layer_3">
          <g id="Layer_1_00000047040223050949772260000015762045760020518581_">
            <g id="Layer_4_00000178910712407868860300000017987189705786171814_">
              <g id="Layer_2_00000066493663017185536000000016878208057980606599_">
                <line className="iso_st6" x1={46.1} y1={51} x2={17.4} y2={37.1} />
              </g>
            </g>
          </g>
          <path
            className="iso_st1"
            d="M47.8,33.9c-5.2,1.7-4.9,12.1-5,14.3c0,0-0.2,0.8-0.2,1.2"
          />
          <path
            className="iso_st1"
            d="M48.3,51.7c-0.5-3.9,1.2-7.2,3.5-7.4c2.2-0.2,4.5,2.7,4.9,6.7c0.5,3.9-1.2,7.2-3.5,7.4 C51,58.6,48.8,55.5,48.3,51.7z"
          />
          <path className="iso_st1" d="M62.1,43.3" />
          <path className="iso_st1" d="M63.9,40.9" />
          <path className="iso_st6" d="M15.4,25.8c1.7,1,3.2,5.5,3.2,11.9" />
          <ellipse
            transform="matrix(0.9953 -9.653491e-02 9.653491e-02 0.9953 -4.747 5.3111)"
            className="iso_st8"
            cx={52.5}
            cy={51.7}
            rx={0.5}
            ry={0.7}
          />
          <ellipse className="iso_st9" cx={13.9} cy={34.9} rx={0.3} ry={0.8} />
          <path
            className="iso_st1"
            d="M60.7,57.2l-0.2-2c-0.8-7.9-3.7-16.5-9.4-17.6l-1-0.2c-6.5-0.5-5.5,12.9-5.5,12.9"
          />
          <path
            className="iso_st1"
            d="M55,39.9h-2c-7.6,0.3-6.9,9.2-6.7,10.9l0.2,1.3c1.3,8.4,8.1,11.4,13.1,7.9c1.7-1.2,2.2-2.7,2.2-2.7"
          />
          <path
            className="iso_st6"
            d="M11.2,32.6L11.2,32.6v-2c0.3-3.9,2.5-3.7,2.5-3.7c2.2,0.2,3.4,5.2,3.9,10.4"
          />
        </g>
        <polygon
          className="iso_st1"
          points="100,38.9 116,35.1 115.1,29.3 99.7,32.5  "
        />
      </g>
      <path
        className="iso_st6"
        d="M16.1,29.5l-0.8-0.3c-0.5-0.2-1-0.3-1.7-0.2c-2.9,0.8-2.4,4.8-2.4,5.6l0,0.9c0.7,4.2,4.2,5.7,6.7,4 c0.8-0.5,1.2-1.5,1.2-1.5"
      />
      <path
        className="iso_st6"
        d="M11.9,34.9c-0.3-2.2,0.7-4,1.8-4c1.2-0.2,2.5,1.5,2.7,3.7c0.3,2.2-0.7,4-1.8,4C13.4,38.7,12.1,37.1,11.9,34.9z "
      />
      <line className="iso_st1" x1={83.6} y1={29.7} x2={84.7} y2={42.1} />
    </g>
  </svg>
);

export default SvgComponent;